import posthog from 'posthog-js';

export const developerMode = posthog.isFeatureEnabled('developer-mode');
